/**
 * Interpola um texto, substituindo os token entre chaves pelos
 * valores correspondentes.
 */
export const interpolate = (text: string, replacements: Record<string, string | undefined>) => {
  return text.replace(/\{([^}]+)\}/g, (_, key) => replacements[key] || "");
};

/**
 * Retorna apenas o primeiro e o último nome de um nome completo.
 * Se o nome tiver dois termos ou menos, retorna o nome original.
 */
export function extractFirstAndLastName(fullName: string): string {
  const parts = fullName.trim().split(/\s+/);

  if (parts.length <= 2) {
    return fullName;
  }

  return `${parts[0]} ${parts[parts.length - 1]}`;
}

/**
 * Extrai as partes significativas do nome de uma pessoa:
 * primeiro nome, segundo nome (apenas se o nome completo tiver 3 ou mais partes) e último nome.
 * Funciona para qualquer tipo de pessoa: talento, admin, responsável, etc.
 *
 * Exemplos:
 * - "Maria Santos" → "Maria Santos"
 * - "Maria Clara Maranhão" → "Maria Clara Maranhão"
 * - "João Pedro Alves Lima" → "João Pedro Lima"
 */
export function extractPersonName(fullName: string): string {
  const parts = fullName.trim().split(/\s+/);

  if (parts.length <= 2) {
    return parts.join(" ");
  }

  return [parts[0], parts[1], parts[parts.length - 1]].join(" ");
}

export const getDigits = (s: string) => s.replace(/\D/g, "");
